import { ReactNode } from 'react';

export enum HotelListView {
    FakeTiles = 'fakeTiles',
    OutOfService = 'outOfService',
    NoResult = 'noResult',
    ResultList = 'resultList',
}

export enum AdditionalRenderType {
    Before = 'before',
    After = 'after',
}

export interface AdditionalRenderEntry {
    content: ReactNode;
    position: number;
    type: AdditionalRenderType;
}

export enum IndividualTravelFilter {
    Diving = 'dv',
    Golfing = 'go',
    Kitesurfing = 'ksur',
    Surfing = 'sur',
    Watersports = 'was',
    Windsurfing = 'wsur',
    Wingfoiling = 'wfoi',
    Wintersport = 'wis',
}
